var _switch;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStep301(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 100 100",
    viewBox: "0 0 100 100",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    width: 1,
    height: 1,
    requiredExtensions: "http://ns.adobe.com/AdobeIllustrator/10.0/"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 49.9,
    r: 48.1,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m65.8 25.5-11 21.2-5.8-3.2c0.5-0.2 1-0.3 1.6-0.4s1.1-0.1 1.6-0.1c1.7 0 3.4 0.1 5.2 0.6 1.7 0.4 3.3 1.2 4.7 2.4 1.4 1.1 2.5 2.7 3.4 4.6 0.9 2 1.3 4.5 1.3 7.5 0 3.5-0.8 6.6-2.5 9.1-1.6 2.5-3.8 4.5-6.4 5.8s-5.5 2-8.6 2c-2.4 0-4.9-0.5-7.6-1.5s-4.8-2.3-6.3-4l5.5-8.8c0.7 0.9 1.9 1.8 3.4 2.7s3.1 1.3 4.8 1.3c1.1 0 2.1-0.3 3.2-0.8 1-0.5 1.9-1.4 2.6-2.4 0.7-1.1 1-2.4 1-4 0-2.2-0.6-3.9-1.8-5.2s-2.9-1.9-5-1.9c-1.5 0-2.6 0.1-3.4 0.2s-1.5 0.3-2.2 0.5l-0.2-0.3 8.6-16.1 3.1 1.3h-15.8v-10.5h26.6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep301);
export default __webpack_public_path__ + "static/media/step3-01.3d2ef3a91b6b562197710313d5a75f0a.svg";
export { ForwardRef as ReactComponent };